<pt-widget-nodata [noDataLabel]="noDataLabel" *ngIf="valutations?.length  === 0"></pt-widget-nodata>
<table class='table table-sm table-striped table-borderless' *ngIf="valutations?.length > 0">
  <thead>
  <tr>
    <th scope='col'></th>
    <th class='text-center min-width-60' scope='col'>{{ 'LABELS.YES' | translate }}</th>
    <th class='text-center min-width-60' scope='col'>{{ 'LABELS.NO' | translate }}</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor='let val of valutations; let i = index'>
    <td>
      <p class='risk-title'>
        {{ val?.label }}
        <pt-w-help [help]='val?.help'></pt-w-help>
      </p>
      <p class='risk-description'>{{ val.description }}</p>
    </td>
    <td class='text-center'>
      <pt-icon *ngIf='preview && val.checked === T'
               [key]='IconCheck'
               [size]='20'
               class='text-success'>
      </pt-icon>

      <label *ngIf='!preview && !val.disabled'
             class='m-0 p-1 w-100 form-label'
             for='{{idPrefix}}_radio{{i}}_1'>
<!--        {{idPrefix}}_radio{{i}}_1-->
        <input (click)='checkRow(val, true)'
               [disabled]="val.editable !== null && val.editable !== undefined && !val.editable"
               [checked]='val.checked === T'
               id='{{idPrefix}}_radio{{i}}_1'
               type='radio'>
      </label>

      <pt-icon *ngIf='!preview && val.disabled && val.checked'
               [key]='IconCheck'
               [size]='20'
               class='text-success'>
      </pt-icon>

    </td>
    <td class='text-center'>

      <pt-icon *ngIf='preview && val.checked === F'
               [key]='IconClose'
               [size]='20'
               class='text-danger'>
      </pt-icon>

      <label *ngIf='!preview && !val.disabled'
             class='m-0 p-1 w-100 form-label'
             for='{{idPrefix}}_radio{{i}}_2'>
<!--        {{idPrefix}}_radio{{i}}_2-->
        <input (click)='checkRow(val, false)'
               [disabled]="val.editable !== null && val.editable !== undefined && !val.editable"
               [checked]='val.checked === F'
               id='{{idPrefix}}_radio{{i}}_2'
               type='radio'>
      </label>

      <pt-icon *ngIf='!preview && val.disabled && !val.checked'
               [key]='IconClose'
               [size]='20'
               class='text-success'>
      </pt-icon>

    </td>
  </tr>
  </tbody>
</table>
